import { timeout } from 'ember-concurrency';
import { restartableTask } from 'ember-concurrency';
import Infinity from 'ember-infinity/services/infinity';
import JsonApiInfinityModel, { decorateApiQuery } from 'volta/models/jsonapi-infinity-model';
import Part, { PartResourceName } from 'volta/models/part';
import StoreService from 'volta/services/store';
import { IJsonApiQuery } from 'volta/utils/api/jsonapi-types';
import { defaultErrorHandler } from 'volta/utils/error-utils';
import { lkFilter } from 'volta/utils/filters-utils';

import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { isPresent } from '@ember/utils';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

interface IArgs {
  onChange: (part: Part) => void;
}

export default class PartSelect extends Component<IArgs> {
  @service declare store: StoreService;
  @service declare infinity: Infinity;

  @tracked newPart?: Part;
  @tracked options: Part[] = [];

  @action
  onCreate(option: string, select: any) {
    const part = this.store.createRecord('part');
    part.code = option;
    this.newPart = part;
    this.args.onChange?.(this.newPart);
    select.actions.close();
  }

  @action
  showCreateWhen(term?: string, _options?: any[]) {
    return isPresent(term);
  }

  queryTask = restartableTask(async (term: string) => {
    const apiQuery: IJsonApiQuery = {
      include: 'partType',
      sort: 'code'
    };
    if (term) {
      apiQuery.filter = {
        q: lkFilter(term)
      };
    }
    try {
      await timeout(isPresent(term) ? 600 : 0);
      this.options = await this.infinity.model(
        PartResourceName.singular,
        decorateApiQuery(apiQuery),
        JsonApiInfinityModel
      );
      return this.options;
    } catch (error) {
      return defaultErrorHandler(error);
    }
  });
}
